// src/components/integrations/ChatBotBanner.tsx
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { ParallaxLayer } from "@react-spring/parallax";
import BonsaiImage from "../../assets/integrations/bonkai.svg";
import "./ChatBox.css";

const ChatBotBanner: React.FC<{ offset: number }> = ({ offset }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const Modal = (
		<div className="bonkai-modal-overlay">
			<div
				className="bonkai-modal-content"
				role="dialog"
				aria-modal="true"
			>
				<button
					className="bonkai-modal-close"
					onClick={() => setIsModalOpen(false)}
					aria-label="Close BonkAI modal"
				>
					&times;
				</button>
				<iframe
					src="https://chat.bonkcoin.com/"
					title="BonkAI Chat"
					className="bonkai-modal-iframe"
				/>
			</div>
		</div>
	);

	return (
		<>
			<ParallaxLayer
				key={`ChatBox-${offset}`}
				offset={offset}
			>
				<div className="bonkai-container">
					<div className="bonkai-inner">
						<img
							src={BonsaiImage}
							alt="BonkAI"
							className="bonkai-image"
						/>
						<button
							className="bonkai-button"
							onClick={() => setIsModalOpen(true)}
						>
							Got a question? Ask BonkAI
						</button>
					</div>
				</div>
			</ParallaxLayer>

			{isModalOpen && ReactDOM.createPortal(Modal, document.body)}
		</>
	);
};

export default ChatBotBanner;
